<div class="crossIcon" (click)="dismissModal()">
  <ion-icon name="close-outline"></ion-icon>
</div>
<ion-content class="ion-no-padding">
  <div class="contents">
    <ion-img class="success-mes-img" src="assets/images/successmessage.svg"></ion-img>
    <p class="success-mes-text">
      {{'requestproductsubmittedsuccessfully' | language : 'Product Request Submitted Successfully'}}
    </p>
  </div>
</ion-content>